import { render } from "./DeliveryAppSection.vue?vue&type=template&id=22a9411c&scoped=true"
import script from "./DeliveryAppSection.vue?vue&type=script&lang=js"
export * from "./DeliveryAppSection.vue?vue&type=script&lang=js"

import "./DeliveryAppSection.vue?vue&type=style&index=0&id=22a9411c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a9411c"]])

export default __exports__